// extracted by mini-css-extract-plugin
export default {"tooltip-style":"Tooltip_tooltip-style__4-CrG","close":"Tooltip_close__ASw4u"};